/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import Flex from "@atg/icf-react-components/components/Flex";
import SvgIcon from "@atg/icf-react-components/components/SvgIcon";
import Text from "@atg/icf-react-components/components/Text";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { selectTwoFactorAuthEmailAddress } from "~/features/auth/selectors";

const TwoFactorAuthEmailSent: FC = () => {
  const { t } = useTranslation("auth");
  const email = useSelector(selectTwoFactorAuthEmailAddress);

  return (
    <Flex gap="16" alignItems="center" margin="16 0 34 0">
      <SvgIcon name="emailOutlined" fill="primaryDark" size="large" style={{ width: "105", height: "105" }} />
      <Text variant="heading_2xl" textAlign="center">
        {t("two_factor_auth.modal.text.email_sent.title")}
      </Text>
      <Text textAlign="center" variant="body_l">
        {t("two_factor_auth.modal.text.email_sent.we_sent_a_link")}
      </Text>
      <Text variant="body_l" fontWeight={600}>
        {email}
      </Text>
      <Flex direction={"row"} gap={"4px"}>
        <Text style={{ display: "inline" }}>{t("two_factor_auth.modal.text.email_sent.contact_support_text")}</Text>{" "}
        <Link color="primaryDark" to={"/app/support/contact"}>
          {t("two_factor_auth.modal.text.email_sent.contact_support_link")}
          <Text style={{ display: "inline" }}>.</Text>
        </Link>
      </Flex>
    </Flex>
  );
};

export default TwoFactorAuthEmailSent;
